import AntdIcon from "./antd_icon";
import React, {useEffect, useState} from "react";
import {Breadcrumb} from 'antd';
import {useAccountStore} from "../../stores/useAccountStore";
import {Link, matchPath, useLocation} from "react-router-dom";


const MyBreadCrumb = () => {
    const location = useLocation();
    const {account} = useAccountStore();
    const {resources} = account;
    const [list, setList] = useState([]);

    /**
     * 根据路径查找资源
     * @param path
     * @returns {*}
     */
    const findResources = (path) => {
        // 查找该资源
        let item = resources.find(_ => _.path === path);
        if (!item) {
            for (let i = 0; i < resources.length; i++) {
                // resources 中父级目录项 path 可能为 null，需跳过（v6+ matchPath 传空 path 会抛错）
                if (resources[i].path && matchPath({path: resources[i].path, end: false}, path) != null) {
                    if (!item || resources[i].path.length > item.path.length) {
                        item = resources[i];
                    }
                }
            }
        }
        return item;
    }

    /**
     * 当路由发生变化
     * @param route
     */
    const routeChange = (route) => {
        // console.log(route); // 这个route里面有当前路由的各个参数信息
        // setPath(route.pathname)
        let item = findResources(route.pathname);
        let list = [];
        while (item) {
            list.unshift(item);
            item = resources.find(_ => _.id === item.pid);
        }
        setList(list);
    }

    /**
     * 路由监听（v6 起无 history.listen，改用 useLocation 变化触发）
     */
    useEffect(() => {
        routeChange(location);
    }, [location.pathname]);


    if (list.length === 0) return null; // 如果没有父节点，则不显示面包屑
    return (
        <Breadcrumb separator=">">
            {list.map((item, index) => (
                <Breadcrumb.Item key={index}>
                    {item.type === 0 && item.path
                        ? <Link to={item.path}>
                            {item.icon && <AntdIcon name={item.icon} style={{marginRight: 5}}/>}
                            {item.title}
                        </Link>
                        : <>
                            {item.icon && <AntdIcon name={item.icon} style={{marginRight: 5}}/>}
                            {item.title}
                        </>
                    }

                </Breadcrumb.Item>
            ))}
        </Breadcrumb>
    );
}

export default MyBreadCrumb;
